import { render, staticRenderFns } from "./IconSvgBmp.vue?vue&type=template&id=64bea380&scoped=true&"
import script from "./IconSvgBmp.vue?vue&type=script&lang=js&"
export * from "./IconSvgBmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bea380",
  null
  
)

export default component.exports